import { render } from "./AddIndispo.vue?vue&type=template&id=39fd3d49"
import script from "./AddIndispo.vue?vue&type=script&lang=ts"
export * from "./AddIndispo.vue?vue&type=script&lang=ts"

import "./AddIndispo.vue?vue&type=style&index=0&id=39fd3d49&lang=scss"
script.render = render

export default script